export const easing = {
  bezier: 'cubic-bezier(0.15, 0.15, 0, 1)',
};
